export default "__VITE_ASSET__Tre0RtW2__"